export default {
  label: {
    man: 'Man',
    woman: 'Woman',
    office: 'Organization',
    notClassified: 'Not Classified',
  },
};
